
import { EMPTY, Observable, of as observableOf } from 'rxjs'
import { catchError, defaultIfEmpty, mergeMap } from 'rxjs/operators'
import { FilterType } from 'shared'

export class FetchError extends Error {

  public readonly type: FilterType
  public readonly source?: Error

  constructor(type: FilterType, source?: Error) {
    super(`No content for: ${type}`)
    this.type = type
    this.source = source

    Object.setPrototypeOf(this, FetchError.prototype)
  }
}

export class EmptyFetchError extends FetchError {
  constructor(type: FilterType) {
    super(type)

    Object.setPrototypeOf(this, EmptyFetchError.prototype)
  }
}

export function createErrorOnEmpty(type: FilterType) {
  return new EmptyFetchError(type)
}

export function createErrorOnEmptyPipe(piped: (err: any) => void) {
  return (errOrContent: any) => {
    if (errOrContent instanceof EmptyFetchError) {
      piped(errOrContent)
      return EMPTY
    }

    return observableOf(errOrContent)
  }
}

export function createTypedErrorPipe(type: FilterType, piped: (err: any) => void) {
  return (error: any) => {
    piped(new FetchError(type, error))

    return EMPTY
  }
}

export function createHandledPipe<T>(type: FilterType, observable: Observable<T>, piped: (err: any) => void): Observable<any> {
  return observable.pipe(
    defaultIfEmpty<T | EmptyFetchError, any>(createErrorOnEmpty(type)),
    mergeMap(createErrorOnEmptyPipe(piped)),
    catchError(createTypedErrorPipe(type, piped))
  )
}
export default EmptyFetchError
